import { ORGANIZATION_CONSTANTS } from '@/common/constants.js';

/**
 * 根据组织 ID 判断是否需要隐藏特定元素
 * @param {string} organizeId
 * @returns {boolean}
 */
export function isRestrictedOrg(organizeId) {
  if (!organizeId) return false;
  return ORGANIZATION_CONSTANTS.RESTRICTED_ORG_IDS.includes(String(organizeId));
}

/**
 * 从用户对象中提取 organizeId
 * @param {Object} user
 * @returns {string}
 */
export function getOrganizeIdFromUser(user = {}) {
  return (
    user.organizeid ||
    (user.userInfo && user.userInfo.organizeid) ||
    ''
  );
}

/**
 * 如果组织受限则返回受限组织默认 tab，否则返回原值
 * @param {number} tab
 * @param {Object} user
 * @returns {number}
 */
export function getInitialTabValue(tab = 0, user = {}) {
  const organizeId = getOrganizeIdFromUser(user);
  if (isRestrictedOrg(organizeId)) {
    return ORGANIZATION_CONSTANTS.RESTRICTED_ORG_DEFAULT_TAB;
  }
  return tab;
}


